var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"modal",attrs:{"title":"Histórico do atendimento","extraLarge":""},scopedSlots:_vm._u([{key:"footer",fn:function({ cancel }){return [_c('rkm-button',{attrs:{"color":"secondary"},on:{"click":cancel}},[_vm._v(" Fechar ")])]}}])},[_c('FormHistoricoAmbulatorio',{attrs:{"data":_vm.model.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }